import { Link } from 'react-router-dom';
import { allCategories } from '@/utils/news';

export default function SiteFooter() {
  const year = new Date().getFullYear();
  return (
    <footer className="w-full bg-primary-800 text-primary-50">
      <div className="w-full px-4 md:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-md bg-primary-50 text-primary-800 flex items-center justify-center font-heading font-black text-lg">
                9
              </span>
              <span className="font-heading font-black text-xl">9·1牛网</span>
            </div>
            <p className="text-sm leading-relaxed text-primary-100/85 max-w-md">
              9·1牛网是面向大陆华语用户的综合资讯平台，聚焦新闻时事、娱乐动态与生活实用信息，帮助用户高效获取有价值的内容。
            </p>
          </div>
          <div>
            <h4 className="font-heading font-bold text-base mb-4">内容频道</h4>
            <ul className="space-y-2 text-sm">
              {allCategories.map((cat) => (
                <li key={cat.key}>
                  <Link to={`/category/${cat.key}`} className="text-primary-100/85 hover:text-accent-300 transition-colors">
                    {cat.name}频道
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/search" className="text-primary-100/85 hover:text-accent-300 transition-colors">
                  搜索资讯
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4 className="font-heading font-bold text-base mb-4">关于本站</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-primary-100/85 hover:text-accent-300 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-primary-100/85 hover:text-accent-300 transition-colors">
                  联系我们
                </Link>
              </li>
              <li className="text-primary-100/60">商务合作：bd@91niu.example.com</li>
            </ul>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-primary-700 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-primary-100/70">
          <p>© {year} 9·1牛网 版权所有 · 本站内容为演示示例，如有雷同纯属巧合</p>
          <p>备案号：京ICP备00000000号-1 · 互联网信息服务资质（演示）</p>
        </div>
      </div>
    </footer>
  );
}